import {
    IonButton,
    IonButtons,
    IonCard,
    IonIcon,
    IonItem,
    IonItemDivider,
    IonLabel,
    IonList,
    IonSpinner,
    IonText,
    IonTitle,
    IonToolbar,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonContent,
    useIonViewWillEnter,
} from "@ionic/react";
import { addCircleOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import { selectUsersAvailable } from "../../../store/formsubmitted/selectors/selectUsersAvailable";
import { clearCreateFilters, setMaxListAvailableIndex, setPreselectAllUsers, setPreselectUser } from "../../../store/formsubmitted";
import { UserSearchBar } from "./UserSearchBar";
import { selectFilters } from "../../../store/formsubmitted/selectors/selectFilters";
import { UserSelectorOrganizationFilter } from "./UserSelectorOrganizationFilter";

export const UserSelector = () => {
    const [isInfiniteDisabled, setInfiniteDisabled] = useState<boolean>(false);
    const dispatch = useDispatch();
    const users = useSelector(selectUsersAvailable);
    const maxDataList = useSelector((state: RootState) => state.formSubmittedSlice.maxListAvailableIndex);
    const state = useSelector((state: RootState) => state.formSubmittedSlice)
    const createFilters = useSelector(selectFilters);

    // Logica para IonInfiniteScroll
    const pushData = () => {
        dispatch(setMaxListAvailableIndex(maxDataList + 20));
    }

    const loadData = (ev: any) => {
        setTimeout(() => {
            pushData();
            ev.target.complete();
            if (users.length === 10000) {
                setInfiniteDisabled(true);
            }
        }, 500);
    }

    useIonViewWillEnter(() => {
        dispatch(setMaxListAvailableIndex(20));
    });

    const handlePreselectAll = async () => {
        dispatch(setPreselectAllUsers(users));
      };

    return (
        <IonCard style={{ height: "75vh" }} class="ion-no-margin">
            <IonToolbar>
                <IonTitle size="small" style={{ fontWeight: 500 }}>
                    Disponibles {users && <span>({users.length})</span>} {/* Según resultado de búsqueda */}
                </IonTitle>
                <IonButtons slot="end">
                    {!!users.length && (
                        <IonButton fill="solid" size="small" color="primary" onClick={handlePreselectAll}>
                            <small>Agregar todos</small>
                            <IonIcon icon={addCircleOutline} slot="end" />
                        </IonButton>
                    )}
                </IonButtons>
            </IonToolbar>
            <UserSearchBar /> {/*SearchBar para buscar las usuarios que se asignarán a la plantilla*/}
            <IonCard color="transparent">
                <IonItemDivider>
                    Filtros personalizados
                    {(createFilters.organization.code || createFilters.businessArea.code) && (
                        <IonButtons slot="end">
                            <IonButton color="danger" onClick={() => dispatch(clearCreateFilters())}>
                                Limpiar filtro
                            </IonButton>
                        </IonButtons>
                    )}
                </IonItemDivider>
                <section style={{ display: "flex", overflow: "auto", padding: 6 }}>
                    <UserSelectorOrganizationFilter /> {/*Seleccion de filtro por Cliente*/}
                </section>
            </IonCard>
            {/* Listado de usuarios filtrados. Para que funcione IonInfiniteScroll es necesario darle altura al IonContent */}
            <IonContent style={{ overflow: "scroll", height: "50vh" }}>
                <IonList>
                    {state.findUserListStatus === "succeeded" && users.slice(0, maxDataList).map((item) => (
                        <IonItem key={item.user.id}>
                            <IonLabel>
                                <h2 style={{ fontWeight: 700 }}>
                                    <IonText color="primary">{item.user.name}</IonText>
                                </h2>
                                <h4>
                                    <IonText color="medium" style={{ fontWeight: 500 }}>
                                        {item.location.name}
                                    </IonText>
                                </h4>
                            </IonLabel>
                            <IonButton
                                fill="clear"
                                onClick={() => {
                                    dispatch(setPreselectUser(item));
                                }}
                                size="large"
                            >
                                <IonIcon icon={addCircleOutline} />
                            </IonButton>
                        </IonItem>
                    ))}
                    {state.findUserListStatus === "pending" && (
                        <p className="ion-text-center">
                            <IonSpinner />
                        </p>
                    )}
                </IonList>
                <IonInfiniteScroll onIonInfinite={loadData} threshold="10px" disabled={isInfiniteDisabled}>
                    <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Cargando más datos..." />
                </IonInfiniteScroll>
            </IonContent>
        </IonCard>
    );
};
